
import React, { Component } from 'react'
import ToastMsg from '../../Components/ToastMsg/ToastMsg'
import CommonGridHeader, { CommonPatientCard, CommonPatientDetails, DeletePopup, ToolsField, ToolsFieldWithMic, ReasonPopup, NewToolsFieldWithMic, OpenWebCamPopUP } from '../../Components/Common Components/CommonComponents'
import { Colors } from '../../Styles/Colors'
import { Autocomplete, Box, Button, Dialog, IconButton, Menu, MenuItem, Modal, TextField, Tooltip, Typography } from '@mui/material'
import { DataGrid } from '@mui/x-data-grid'
import { ImagePaths } from '../../Utility/ImagePaths'
import { getCachevalue, localGetItem } from '../../Utility/Services/CacheProviderService'
import RestAPIService from '../../Utility/Services/RestAPIService'
import { Serviceurls } from '../../Utility/API/Serviceurls'
import { CheckAccessFunc } from '../../Components/CommonFunctions/CommonFunctions'
import MoreVertIcon from '@mui/icons-material/MoreVert';
import PrintPreviewPop from '../../Components/Common Components/PrintPreviewPop'
import { Bucket_Name } from '../../Utility/Constants'
import { dataURItoFile } from '../../Components/CommonFunctions/CommonFunctions';
import { Close } from '@material-ui/icons'
import Item from 'antd/es/list/Item'

let isUser = null;
let userAccess = null;
let AWS = require('aws-sdk');
let s3 = new AWS.S3({
    signatureVersion: 'v4',
    region: "ap-south-1",
    params: { Bucket: Bucket_Name },
});

export default class HistopathologyReport extends Component {
    constructor(props) {
        super(props)
        this.state = {
            patientData: {},
            attender_mobile: '',
            attender_name: '',
            page: 0,
            pageSize: 10,
            testReportData: [],
            testServiceData: [],
            ResultTextData: "",
            EditorDisable: false,
            editedText: '',
            confirmpopup: false,
            ResultPDF: [],
            uploaded_attachment:[],
            printPreviewPop: false,
            printPreviewData: '',
            pdfName: '',
            showNewBill: false,
            printImgData: '',
            selectedID: null,
            isInfoMsg: false,
            isInfoMsgText: '',
            templateData: [],
            selectedTemplate: null,
            selectedTemplateResult: '',
            templatePopUpOpen: false,
            tempPost: false,
            isSave: false,
            isDispatchshown: false,
            selectedServiceData: null,
            checkpaymentstatus: false,
            isLoader: false,
            successMsg: false,
            successMsgText: '',
            isErrorMsg: false,
            isErrorMsgText: '',
            anchorEl: null,
            selectedRow: null,
            isSelected: false,
            selectedOption: "",
            patientInfo: {},
            signatureData: [],
            selectedLabIncharge: null,
            selectedPathologist1: null,
            selectedPathologist2: null,
            uploaded_attachment:[],
            current_attachment:[],
            selectedImageIndex: null,
            selectedUploadData: null,
            uploadedImages: [],
            selectedImage: {},
            pdfPreview: false,
            pdfData: '',
            ImgData: '',
            disableBtn: false,
            imgCapClked: false,
            CapturedImg: null,
            confirmationPopup: false,
            selectedItem: {},
            selectedImageName: [],
            selectedImageRowId: null,
            uploadData: {},
            selectedDeletedIndex: [],
        }
        this.editorRef = React.createRef();
        this.uploadImage = React.createRef();
    }

    componentDidMount() {
        let showNewBill = localGetItem('isNewBilling')
        this.setState({ showNewBill: JSON.parse(showNewBill) }, () => {
            isUser = JSON.parse(localGetItem('loggedInUserInfo'))
            userAccess = CheckAccessFunc("Histopathology", "Home", "Histopathology Home", null, "Tab")?.editAccess;
            let patientData = JSON.parse(getCachevalue('HistoPatientData')) || this.props.history.location?.state?.patientData;
            let checkpaymentstatus = localGetItem('op_test_report_payment_check') === 'true' ? true : false;
            this.setState({
                patientData: patientData,
                checkpaymentstatus: checkpaymentstatus
            }, () => this.getPatientTestReportData(), this.getSignatureData())
        })
    }

    getPatientTestReportData = () => {
        try {
            const { patientData } = this.state;

            if (!patientData?.patient_id) {
                this.errorMessage('Patient ID is required');
                return;
            }

            this.setState({ isLoader: true });

            let params = `?patient_id=${patientData.patient_id}`;

            if (this.props.history?.location?.state?.selectedDate) {
                const date = new Date(this.props.history.location?.state?.selectedDate);
                const formattedDate = date.toISOString().split('T')[0];
                params += `&date=${formattedDate}`;
            } else if (patientData?.invoice_date) {
                const date = patientData.invoice_date.slice(0, 10).split('-');
                const invoiceDate = date[2] + "-" + date[1] + "-" + date[0];
                params += `&date=${invoiceDate}`;
            }

            if (patientData?.ip_admission_id) {
                params += `&admission_id=${patientData.ip_admission_id}`;
            } else if (patientData?.appointment_id) {
                params += `&appointment_id=${patientData.appointment_id}`;
            }

            RestAPIService.getAll(Serviceurls.HISTOPATHOLOGY_REPORT_DATA + params)
                .then((response) => {
                    if (response.data.status === 'success') {
                        const testDatas = response.data.test_datas || [];
                        const patientData = response.data.patient_data;

                        const allTests = testDatas.map((test, index) => ({
                            id: test.result_id || index,
                            sno: (index + 1).toString().padStart(2, '0'),
                            testName: test.service_name || null,
                            service_head: test.service_head_name || null,
                            specimen: test.specimen || null,
                            sampleId: test.sample_id || null,
                            overallSpecimenSequence: test.overall_specimen_seq_no || null,
                            specimen_id: test.specimen_id || null,
                            sampleType: test.sample_type || null,
                            location: test.location || null,
                            isOutsource: test.is_outsource || false,
                            sampleCollected: test.sample_collected || false,
                            invoiceNumber: test.invoice_number || null,
                            paymentStatus: test.payment_status || null,
                            status: test.sample_collected ? 'Completed' : 'In Progress',
                            result_data: test.result_data || "",
                            result_document: test.result_document || [],
                            template_name: test.template_name || null,
                            result_status: test.result_status || null,
                            collected_date: test.collected_date || null,
                            result_completed_date: test.result_completed_date || null,
                            service_id: test.service_id || null,
                            service_head_id: test.service_head_id || null,
                            esign_left_id: test.esign_left_id || null,
                            esign_center_id: test.esign_center_id || null,
                            esign_right_id: test.esign_right_id || null
                        }));

                        this.setState({
                            testServiceData: allTests,
                            patientInfo: patientData,
                            isLoader: false
                        });
                    } else {
                        this.setState({ isLoader: false });
                        this.errorMessage(response.data.message);
                    }
                }).catch((error) => {
                    this.setState({ isLoader: false });
                    if (error?.response?.data?.message) {
                        this.errorMessage(error.response.data.message);
                    } else {
                        this.errorMessage(error.message);
                    }
                });
        } catch (error) {
            this.setState({ isLoader: false });
            this.errorMessage(error.message);
        }
    }

    handleHistopathologyUpload = (rowData) => {
        this.setState({
            templatePopUpOpen: true,
            selectedServiceData: rowData,
            uploaded_attachment: rowData?.result_document || [],
            selectedLabIncharge: rowData?.esign_left_id ? this.state.signatureData.find(sig => sig.id === rowData.esign_left_id) : null,
            // selectedPathologist1: rowData?.esign_center_id ? this.state.signatureData.find(sig => sig.id === rowData.esign_center_id) : null,
            selectedPathologist2: rowData?.esign_right_id ? this.state.signatureData.find(sig => sig.id === rowData.esign_right_id) : null,
            selectedTemplate: rowData?.template_name ? rowData.template_name : null,
            ResultTextData: ""
        }, () => {
            this.getHistopathologyTemplateData()
            this.getSignatureData();
        });
    }

    handleViewResult = (rowData) => {
        this.setState({
            selectedServiceData: rowData,
            ResultTextData: rowData?.result_data || "",
            ResultPDF: rowData?.result_document || [],
            selectedLabIncharge: rowData?.esign_left_id ? this.state.signatureData.find(sig => sig.id === rowData.esign_left_id) : null,
            // selectedPathologist1: rowData?.esign_center_id ? this.state.signatureData.find(sig => sig.id === rowData.esign_center_id) : null,
            selectedPathologist2: rowData?.esign_right_id ? this.state.signatureData.find(sig => sig.id === rowData.esign_right_id) : null,
        }, this.setState({
            templatePopUpOpen: true,
            EditorDisable: true,
            isDispatchshown: rowData?.status === "Dispatched" ? false : true
        }));
    }

    handlePrintReport = (rowData) => {
        if (this.state.checkpaymentstatus &&
            (rowData?.paymentStatus?.toLowerCase() === "not paid" ||
                rowData?.paymentStatus?.toLowerCase() === "partial") &&
            !this.state.patientData?.ip_admission_id) {
            this.setState({
                isInfoMsg: true,
                isInfoMsgText: "Payment is not completed. For printing the report, please complete the payment.",
            });
        } else {
            this.PrintReport(rowData.id, rowData);
        }
    }

    getHistopathologyTemplateData = () => {
        try {
            this.setState({ tempPost: true });
            RestAPIService.getAll(Serviceurls.HISTOPATHOLOGY_RESULT_TEMPLATE + '?service_head=' + this.state.selectedServiceData?.service_head + '&service_name=' + this.state.selectedServiceData?.testName)
                .then((response) => {
                    if (response.data.status === 'success') {
                        this.setState({
                            templateData: response.data.data || [],
                            ResultTextData: this.state.selectedServiceData?.result_data || "",
                            tempPost: false
                        }, () => {
                            if (this.state.selectedServiceData?.result_data) {
                                this.setState({
                                    ResultTextData: this.state.selectedServiceData?.result_data,
                                    selectedTemplate:
                                        response.data.data.find(t => t.template_name ===this.state.selectedServiceData?.template_name ) || null
                                });
                                return;
                            }

                            if (response.data.data.length === 1) {
                                this.setState({
                                    selectedTemplate: response.data.data[0],
                                    ResultTextData: response.data.data[0]?.template_data || ""
                                })
                            }
                
                        });
                    }
                }).catch((error) => {
                    this.setState({ tempPost: false });
                    if (error?.response?.data?.message) {
                        this.errorMessage(error.response.data.message);
                    } else {
                        this.errorMessage(error.message);
                    }
                });
        } catch (error) {
            this.setState({ tempPost: false });
            this.errorMessage(error.message);
        }
    }

    getSignatureData = () => {
        try {
            RestAPIService.getAll(Serviceurls.HISTOPATHOLOGY_ESIGN_CONFIG)
                .then((response) => {
                    if (response.data.status === 'success') {
                        let data = response.data.data?.filter((item) => item.status)
                        this.setState({
                            signatureData: data || []
                        });
                    }
                }).catch((error) => {
                    if (error?.response?.data?.message) {
                        this.errorMessage(error.response.data.message);
                    } else {
                        this.errorMessage(error.message);
                    }
                });
        } catch (error) {
            this.errorMessage(error.message);
        }
    }

    postResultTemplateData = (ResultData, isForSave = false, isForCompleted = false, file, imageCap) => {
        try {
            const data = new FormData();
            data.append('result_id', this.state.selectedServiceData?.id);
            data.append('result_data', ResultData ? ResultData : this.state.editedText ? this.state.editedText : "");
            data.append('update_status', isForSave ? 'Result Saved' : isForCompleted ? 'Completed' : "Dispatched");
            data.append('template_name', this.state.selectedTemplate?.template_name ? this.state.selectedTemplate?.template_name : this.state.selectedTemplate || '');

            const fileList = file;
            let UploadedList = []

            if (fileList?.length > 0) {
                fileList.forEach((fileItem) => {
                    if (typeof fileItem?.document_file === "object") {
                        data.append('result_files', fileItem.document_file, fileItem.document_name);
                    }else if (typeof fileItem?.document_file === 'string') {
                        UploadedList.push(fileItem)
                    }
                });
            }
            if (imageCap) {
                data.append('result_files', dataURItoFile(imageCap, "result_document.jpg"), "result_document.jpg");
            }

            if (UploadedList?.length > 0) {
                data.append('result_document', JSON.stringify(UploadedList));
            } else {
                data.append('result_document', "");
            }

            if (this.state.selectedLabIncharge) {
                data.append('esign_left_id', this.state.selectedLabIncharge.id);
            }
            // if (this.state.selectedPathologist1) {
            //     data.append('esign_center_id', this.state.selectedPathologist1.id);
            // }
            if (this.state.selectedPathologist2) {
                data.append('esign_right_id', this.state.selectedPathologist2.id);
            }

            RestAPIService.create(data, Serviceurls.HISTOPATHOLOGY_REPORT_DATA)
                .then((response) => {
                    if (response.data.status === 'success') {
                        this.successMessage(response.data.message);
                        this.getPatientTestReportData();
                        this.setState({
                            selectedServiceData: null,
                            selectedTemplate: null,
                            selectedTemplateResult: '',
                            templatePopUpOpen: false,
                            tempPost: false,
                            isSave: false,
                            EditorDisable: false,
                            ResultTextData: "",
                            confirmpopup: false,
                            editedText: ''
                        });
                    }
                }).catch((error) => {
                    if (error?.response?.data?.message) {
                        this.errorMessage(error?.response.data.message);
                    } else {
                        this.errorMessage(error.message);
                    }
                });
        } catch (error) {
            this.errorMessage(error.message);
        }
    }

    async getS3KeyPR(doc_name, docName) {
        try {
            const response = await RestAPIService.getAllTwo(Serviceurls.AWS_URL_GET + "?doc_key=" + doc_name);

            if (response.data.status === "success") {
                const Data = response?.data?.data;
                let printPreviewData = Data;
                let printImgData = "";

                if (docName.includes("jpg")) {
                    const fileResponse = await fetch(Data);
                    const blob = await fileResponse.blob();
                    printImgData = URL.createObjectURL(blob);
                    printPreviewData = "";
                }
                this.setState({
                    printPreviewPop: true,
                    printPreviewData,
                    printImgData,
                    pdfName: doc_name ? doc_name : 'PDF Preview'
                });
                return (Data);
            }
        } catch (e) {
            this.setState({
                isErrorMsg: true,
                isErrorMsgText: "Error fetching S3 URL"
            });
        }
    }

    handleStyleChange = (command) => {
        document.execCommand(command, false, null);
    };

    PopupClose = () => {
        this.setState({
            confirmpopup: false,
            editedText: ''
        });
    }

    dispatchPopup = (value) => {
        this.setState({
            confirmpopup: true,
            editedText: value
        });
    }

    renderResultUploadPopup = () => {
        try {
            return (
                <Dialog open={this.state.templatePopUpOpen} fullWidth={true} maxWidth={'md'} >
                    <Box component={'div'}>
                        <Box component={'div'} display={'flex'} justifyContent={'flex-end'} padding={'0.5vw'} alignItems={'center'} mt={"0.5vw"} mr={'0.5vw'}>
                            

                            {/* Lab Incharge Dropdown */}
                            <Autocomplete
                                value={this.state.selectedLabIncharge ? this.state.selectedLabIncharge : null}
                                options={this.state.signatureData || []}
                                disabled={this.state.selectedServiceData?.result_status === 'Completed' || this.state.selectedServiceData?.result_status === 'Dispatched'}
                                getOptionLabel={(option) => typeof (option) === 'string' ? option : `${option?.role_name} - ${option?.name}`}
                                size='small'
                                onChange={(e, value) => {
                                    this.setState({
                                        selectedLabIncharge: value
                                    });
                                }}
                                sx={{ width: '15vw', mr: '1vw' }}
                                renderInput={(params) => <TextField {...params} label='Select Left E-Sign' />}
                            />

                            {/* Pathologist 1 Dropdown */}
                            {/* <Autocomplete
                                value={this.state.selectedPathologist1 ? this.state.selectedPathologist1 : null}
                                options={this.state.signatureData?.filter(person => person.role === 'Pathologist 1') || []}
                                disabled={this.state.selectedServiceData?.result_status === 'Completed' || this.state.selectedServiceData?.result_status === 'Dispatched'}
                                getOptionLabel={(option) => typeof (option) === 'string' ? option : option?.name}
                                size='small'
                                onChange={(e, value) => {
                                    this.setState({
                                        selectedPathologist1: value
                                    });
                                }}
                                sx={{ width: '15vw', mr: '1vw' }}
                                renderInput={(params) => <TextField {...params} label='Pathologist 1' />}
                            /> */}

                            {/* Pathologist 2 Dropdown */}
                            <Autocomplete
                                value={this.state.selectedPathologist2 ? this.state.selectedPathologist2 : null}
                                options={this.state.signatureData || []}
                                disabled={this.state.selectedServiceData?.result_status === 'Completed' || this.state.selectedServiceData?.result_status === 'Dispatched'}
                                getOptionLabel={(option) => typeof (option) === 'string' ? option : `${option?.role_name} - ${option?.name}`}
                                size='small'
                                onChange={(e, value) => {
                                    this.setState({
                                        selectedPathologist2: value
                                    });
                                }}
                                sx={{ width: '15vw', mr: '2vw' }}
                                renderInput={(params) => <TextField {...params} label='Select Right E-Sign' />}
                            />
                            <Autocomplete
                                value={this.state.selectedTemplate ? this.state.selectedTemplate : null}
                                options={this.state.templateData ? this.state.templateData : []}
                                disabled={this.state.selectedServiceData?.result_status === 'Completed' ? true : this.state.selectedServiceData?.result_status === 'Dispatched' ? true : false}
                                getOptionLabel={(option) => typeof (option) === 'string' ? option : option?.template_name}
                                size='small'
                                onChange={(e, value) => {
                                    this.setState({
                                        selectedTemplate: value
                                    }, () => {
                                        if (this.state.selectedTemplate !== null) {
                                            this.setState({
                                                ResultTextData: this.state.selectedTemplate?.template_data
                                            });
                                        } else {
                                            this.setState({
                                                ResultTextData: ""
                                            });
                                        }
                                    });
                                }}
                                sx={{ width: '20vw', mr: '2vw' }}
                                renderInput={(params) => <TextField {...params} label='Select Template' />}
                            />

                            <Button className='Common_Btn_Min_Width' emed_tid='histo_tmp_cls_btn'
                                onClick={() => this.setState({
                                    templatePopUpOpen: false,
                                    selectedServiceData: null,
                                    selectedTemplateResult: '',
                                    ResultTextData: '',
                                    EditorDisable: false,
                                    selectedTemplate: null,
                                    selectedLabIncharge: null,
                                    selectedPathologist1: null,
                                    selectedPathologist2: null
                                })}
                            >
                                <Box component={'img'} src={ImagePaths.LabCloseButton.default} height={'1vw'} width={'1vw'} />
                            </Button>
                        </Box>
                        <NewToolsFieldWithMic
                            FromTestReport={true}
                            selectedServiceData={this.state.selectedServiceData}
                            EditorDisable={this.state.EditorDisable}
                            isDispatchshown={this.state.isDispatchshown}
                            Title={"Result"}
                            EditorRef={this.state.ResultTextData}
                            handleSaveResult={this.postResultTemplateData.bind(this)}
                            handlePostResult={this.postResultTemplateData.bind(this)}
                            handleDispatchResult={this.dispatchPopup.bind(this)}
                            overallHeight={"78vh"}
                            EditorHeight={"53vh"}
                            ResultPDF={[...this.state.uploaded_attachment , ...this.state.ResultPDF]}
                            micTextEditDisabled={true}
                            addSpaceOnTab={true}
                            errorMsg={this.errorMessage.bind(this)}
                        />
                    </Box>
                 
                </Dialog>
            );
        } catch (error) {
            this.errorMessage(error.message);
        }
    }

    errorMessage = (message) => {
        this.setState({
            isErrorMsg: true,
            isErrorMsgText: message
        });
    }

    successMessage = (message) => {
        this.setState({
            successMsg: true,
            successMsgText: message
        });
    }

    msgClose() {
        this.setState({
            isErrorMsg: false,
            isErrorMsgText: '',
            successMsg: false,
            successMsgText: '',
            isInfoMsg: false,
            isInfoMsgText: '',
        });
    }

    PrintReport = (id, list) => {
        try {
            const date = new Date();
            const formattedDate = date.toISOString().split('T')[0];
            let params = `?patient_id=${this.state.patientData.patient_id}`+`&date=${formattedDate}` +`&result_id=${id}`;
            if (this.state.checkpaymentstatus && (list?.paymentStatus?.toLowerCase() === "not paid" || list?.paymentStatus?.toLowerCase() === "partial") && !this.state.patientData?.ip_admission_id) {
                this.setState({
                    isInfoMsg: true,
                    isInfoMsgText: "Payment is not completed. For printing the report, please complete the payment.",
                    isPrintClicked: false,
                });
            } else {
                RestAPIService.getAll(Serviceurls.HISTOPATHOLOGY_REPORT_DATA + params + "&export_type=pdf" + '&check_payment_status=true').
                    then((response) => {
                        if (response.status == 204) {
                            this.setState({
                                isInfoMsg: true,
                                isInfoMsgText: "Payment is not completed. For printing the report, please complete the payment.",
                            });
                        } else {
                            const file = new Blob(
                                [response.data],
                                { type: 'application/pdf' });
                            const fileURL = URL.createObjectURL(file);
                            window.open(fileURL);
                        }
                        this.setState({
                            selectedOption: ""
                        });
                    }).catch((error) => {
                        this.errorMessage(error.response?.data?.message, false);
                    });
            }
        } catch (error) {
            this.errorMessage(error.message, false);
        }
    }

    printBarCode = (bill_id, line_id) => {
        try {
            RestAPIService.getAllPrint(Serviceurls.HISTOPATHOLOGY_BARCODE_PRINT + '?patient_id=' + this.state.patientData?.patient_id + "&histopathology_bill_summary_id=" + bill_id + "&id=" + line_id)
                .then((response) => {
                    const file = new Blob(
                        [response.data],
                        { type: 'application/pdf' });
                    const fileURL = URL.createObjectURL(file);
                    window.open(fileURL);
                    this.setState({
                        anchorEl: null,
                        selectedRow: null,
                        isSelected: false
                    });
                }).catch((error) => {
                    this.errorMessage(error.response?.data?.message, false);
                });
        } catch (error) {
            this.errorMessage(error.message, false);
        }
    }

    async getS3Key(doc_key, id) {
        try {
          const response = await RestAPIService.getAllTwo(Serviceurls.AWS_URL_GET + "?doc_key=" + doc_key);
    
          if (response.data.status === "success") {
            const Data = response.data;
            return {
              data_url: Data.data,
              id: id,
              type: doc_key?.split('.')?.pop() === "pdf" ? "pdf" : "image"
            };
          }
        } catch (e) {
          this.setState({
            isErrorMsg: true,
            isErrorMsgText: "Error fetching S3 URL"
          });
        }
    }

    async sourceOpen(list, subIndex) {
        let tempArr = [];
        const image = (typeof list?.result_document === "string" && list.result_document.trim() !== "")
            ? JSON.parse(list.result_document)
            : list?.result_document ?? [];

        if (image !== null) {
            for (let j = 0; j < image?.length; j++) {
                let doc_key = image[j]?.document_file;
                let id = list.id;

                let getData = await this.getS3Key(doc_key, id);

                const imageDataWithFlag = {
                    ...getData,
                    savedBefore: true,
                };
                tempArr.push(imageDataWithFlag);
            }
            this.setState({
                sourceOpen: true,
                selectedImageIndex: subIndex,
                selectedUploadData: list,
                uploadedImages: tempArr,
                selectedImage: null,
            });
        }
    }
  
  fetchAndConvertToBase64 = async (url) => {
    try {
      const response = await fetch(url);
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      const blob = await response.blob();
      const reader = new FileReader();
      return new Promise((resolve, reject) => {
        reader.onloadend = () => resolve(reader?.result);
        reader.onerror = () => reject(reader?.error);
        reader.readAsDataURL(blob);
      });
    } catch (error) {
      console.error('Error fetching or converting file:', error);
    }
  }

   sourceClose = () => {
    this.setState({ sourceOpen: false, isFile: false, })
    this.getPatientTestReportData();
  }

  onImageRemove = (index) => {
    let deletedArr = [...this.state.uploadedImages];
    deletedArr.splice(index, 1);
    this.setState({
      uploadedImages: [...deletedArr]
    })
  }

  onChangeUP = (imageList, addUpdateIndex) => {
    this.setState({
      uploadedImages: [...this.state.uploadedImages, ...imageList.target.files]
    })
  };

    addImgCapture = (data) => {
      if (data) {
        this.setState((prevState) => {
          return {
            uploadedImages: [...prevState.uploadedImages, dataURItoFile(data, `result_document_${Date.now()}.jpg`)],
            imgCapClked: false
          };
        });
      }
    }

     closeWebCamPop = () => {
    this.setState({
      imgCapClked: false,
      CapturedImg: null
    })
  }

    confirmPopupClose = () => {
    this.setState({
      confirmationPopup: false,
      selectedItem: {}
    })
  }

   deleteUploadImages = (index, list) => {
      try {
        const resultImageArray = (typeof list?.result_document === "string" )
        ? JSON.parse(list.result_document)
        : list?.result_document ?? [];
  
        if (resultImageArray && resultImageArray.length > 0) {
          resultImageArray.splice(index, 1); 
  
          const updatedResultImage = resultImageArray.length > 0 ? JSON.stringify(resultImageArray) : '';
  
          const data = {
            result_id: list?.id,
            result_document: updatedResultImage,  
          };
  
          RestAPIService.delete(Serviceurls.HISTOPATHOLOGY_REPORT_DATA, data)
            .then((response) => {
              if (response.data.status === "success") {
                this.setState({
                  selectedImage: null,
                },
                  () => {
                    this.onImageRemove(index);
                    this.successMessage(response.data.message)
                  });
              }
            })
            .catch((error) => {
              this.setState({
                selectedImage: null,
              }, () => {
                this.errorMessage(error?.response?.data?.message)
              });
            });
        } else {
          this.errorMessage("NoImagesToDelete")
        }
      } catch (error) {
        this.errorMessage("ImageError")
      }
    };

     uploadOutsourceImage = (list) => {
        try {
          const dataForm = new FormData();
          const { uploadedImages } = this.state;
          for (let i = 0; i < uploadedImages.length; i++) {
            if (!uploadedImages[i].id) {
              dataForm.append("result_images", uploadedImages[i]);
            }
            else {
              dataForm.append("result_images", []);
            }
          }
          let dt = new Date().getTime();
          const uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
          const r = (dt + Math.random() * 16) % 16 | 0;
          dt = Math.floor(dt / 16);
          return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
          })
          dataForm.append("uuid", uuid)
          dataForm.append("result_id", list.result_item_id || list.id);
          dataForm.append("result_document", JSON.stringify(list.result_document) || []);

    
          RestAPIService.patch(dataForm, Serviceurls.HISTOPATHOLOGY_REPORT_DATA)
            .then((response) => {
              if (response.data.status === "success") {
                this.setState({
                  uploadedImages: [],
                  selectedImage: {},
                  selectedImageName: [],
                  selectedImageRowId: null,
                  selectedUploadData: [],
                  uploadData: {},
                  selectedDeletedIndex: [],
                  disableBtn: false
                }, () => {
                  this.successMessage(response.data.mesage)
                });
                this.sourceClose(); 
              }
            })
            .catch((error) => {
              this.errorMessage(error.response?.data?.message || "ImageError")
              this.setState({ disableBtn: false })
            });
        } catch (error) {
          this.errorMessage("ImageError")
          this.setState({ disableBtn: false })
        }
      };

    reasonPopupClose = () => {
        this.setState({
            selectedOption: ""
        });
    }

    OutsourceCompletePost = (list) => {
        try{
            const data = {
                update_status: 'Completed',
                result_id: list.result_item_id || list.id,
                result_document: JSON.stringify(list.result_document) || []
            };
        RestAPIService.create(data, Serviceurls.HISTOPATHOLOGY_REPORT_DATA)
        .then((response) => {
            if (response.data.status === 'success') {
                this.successMessage(response.data.message);
                this.getPatientTestReportData();
                this.setState({
                    sourceOpen: false,
                });
            }
        }).catch((error) => {
            if (error?.response?.data?.message) {
                this.errorMessage(error?.response.data.message);
            } else {
                this.errorMessage(error.message);
            }
        });

        }catch(error){
            this.errorMessage(error.message);
        }
    }

    OutsourceDispatchPost = (list) => {
        try{
            const data = {
                update_status: 'Dispatched',
                result_id:  list.result_item_id || list.id,
                result_document: JSON.stringify(list.result_document) || []
            };
        RestAPIService.create(data, Serviceurls.HISTOPATHOLOGY_REPORT_DATA)
        .then((response) => {
            if (response.data.status === 'success') {
                this.successMessage(response.data.message);
                this.getPatientTestReportData();
                this.setState({
                    sourceOpen: false,
                });
            }
        }).catch((error) => {
            if (error?.response?.data?.message) {
                this.errorMessage(error?.response.data.message);
            } else {
                this.errorMessage(error.message);
            }
        });

        }catch(error){
            this.errorMessage(error.message);
        }
    }


    handleOutsourceUpload = (list, subIndex) => {
        const { t } = this.props
        return (
          <>
            <Modal
              open={this.state.sourceOpen}
              onClose={this.sourceClose}
              aria-labelledby="modal-title"
              aria-describedby="modal-description"
              footer={null}
              onCancel={this.sourceClose}
            >
              <Box className='emedhub_popup_outsource_list'>
                {/* Modal Header */}
                <div className='emedhub_popup_title'>
                  <label id="modal-title" className='emedhub_popup_title_left'>{"Test Report"}</label>
                  <div className='emedhub_card_close_button'>
                    <img
                      className='emedhub_popup_title_right'
                      src={ImagePaths.LabCloseButton.default}
                      onClick={this.sourceClose}
                      alt="close"
                    />
                  </div>
                </div>
    
                {/* Modal Content */}
                <div className='emedhub_popup_title_2'>
                  {/* <Typography className='emedhub_popup_title_Header'>{t("SculptureTest")}</Typography> */}
                </div>
                <div className='emedhub_print_popup'>
                  <input
                    type="file"
                    multiple
                    accept="application/pdf"
                    onChange={(e) => this.onChangeUP(e)}
                    ref={this.uploadImage}
                    style={{ display: "none" }}
                  />
                  <div className='image_top_header'>
                    <label className='test_name_style'><b>{"Test Name"}:</b>
                      <span style={{ marginLeft: "5px" }}>{"  " + this.state?.selectedUploadData?.testName}</span>
                    </label>
                    <div className='emedhub_image_upload_button'>
                      <Button
                        size = "small"
                        variant = "contained"
                        sx = {{height: "2vw", textTransform: "capitalize"}}
                        onClick={() => this.uploadImage.current.click()}
                      >
                        {"Upload PDF"}
                        {/* {t("Upload PDF")} */}
                      </Button>
                      <Button size = {"small"}
                        onClick={() => { this.setState({ imgCapClked: true }) }}>
                        <img className='eMed_imgCap_btn' src={ImagePaths.captureImg.default} alt="camera" />
                      </Button>
                    </div>
                  </div>
    
                  {/* Uploaded Images Preview */}
                  <div style={{ display: "flex", width: "100%", overflow: "auto", overflowY: "hidden" }}>
                    {
                      this.state.uploadedImages?.map((item, index) => (
                        <div key={index} className='emedhub_multiple_image_size_outlist'>
                          <img
                            alt="Uploaded Preview"
                            src={item.type === "image" ? item["data_url"] : ImagePaths.DocumentPreview.default}
                            className='emedhub_multiple_image_resolution'
                            onClick={() => {
                              if (item.type === "pdf" && item?.savedBefore) {
                                this.fetchAndConvertToBase64(item["data_url"]).then((base64) => {
                                  base64 = base64?.replace("data:binary/octet-stream;", "data:application/pdf;");
                                  this.setState({ pdfPreview: true, pdfData: base64 })
                                });
                              } else if (item.type === "application/pdf") {
                                this.setState({ pdfPreview: true, pdfData: URL.createObjectURL(item) })
                              } else if(item?.type === "image"){
                                this.setState({ pdfPreview: true, ImgData: item["data_url"] })
                              }
                            }}
                          />
                          <IconButton
                            onClick={() => {
                              this.setState({
                                selectedImage: null
                              })
                              if (item?.type === "image" || item?.type === "pdf") {
                                this.deleteUploadImages(index, this.state.selectedUploadData);
                              } else {
                                this.onImageRemove(index);
                              }
                            }
                            }
                            size='small'
                            className='emedhub_icon_style_outlist'
                          >
                            <Close fontSize='small' />
                          </IconButton>
                        </div>
                      ))}
                  </div>
                </div>
    
                {/* Footer Buttons */}
                <div className='emedhub_popup_button'>
                  <Button
                    variant='outlined'
                    onClick={() => {
                      this.setState({ uploadedImages: []}); // Reset uploaded images
                    }}
                    sx={{ marginRight: "1vw", textTransform: "capitalize" }}
                  >
                    {"Reset"}
                  </Button>
                  <Button
                    disabled={this.state.disableBtn || this.state.uploadedImages?.length === 0 || this.state.selectedUploadData?.result_status === "Completed" || this.state.selectedUploadData?.result_status === "Dispatch"}
                    variant='contained'
                    onClick={() => this.setState({ disableBtn: true }, () => this.uploadOutsourceImage(this.state.selectedUploadData))}
                    sx={{ marginRight: "1vw", textTransform: "capitalize" }}
                  > 
                    {"Save"}
                  </Button>
                  <Button
                    disabled={ this.state.selectedUploadData?.result_status === "Completed" || this.state.selectedUploadData?.result_status === "Dispatch" || this.state.selectedUploadData?.result_status === "In Progress" }
                    variant='contained'
                    onClick={() => this.setState({ disableBtn: true }, () => this.OutsourceCompletePost(this.state.selectedUploadData))}
                    sx={{ marginRight: "1vw", textTransform: "capitalize" }}
                  >
                    {"Complete"}
                  </Button>
                  <Button
                    disabled={ this.state.selectedUploadData?.result_status === "Dispatch" || this.state.selectedUploadData?.result_status === "In Progress" || this.state.selectedUploadData?.result_status === "Result Saved"} 
                    variant='contained'
                    onClick={() => this.setState({ disableBtn: true }, () => this.OutsourceDispatchPost(this.state.selectedUploadData))}
                    sx={{ marginRight: "1vw", textTransform: "capitalize" }}
                  >
                    {"Dispatch"}
                  </Button>
                </div>
              </Box>
            </Modal>
    
          </>
        )
      }

    revertHistopathologyResult = (comments) => {
        try {
            let states = this.state;
            let patientData = states.patientData;
            let data = {};
            data = {
                'type': 'HISTOPATHOLOGY',
                'result_details_id': states.selectedID,
                'patient_id': patientData?.patient_id,
                'remarks': comments,
                'revert_type': "histopathology_result",
                'appointment_id': patientData?.appointment_id || null
            };

            RestAPIService.create(data, Serviceurls.REVERT_HISTOPATHOLOGY_URL)
                .then((response) => {
                    if (response.data.status == 'success') {
                        this.setState({
                            successMsg: true,
                            successMsgText: response.data.message,
                            selectedOption: "",
                        });
                        if (!isUser?.is_user || isUser?.permission_access?.common?.allow_histo_revert) {
                            this.getPatientTestReportData();
                        }
                    }
                }).catch((e) => {
                    if (e.response.data.status === "fail") {
                        this.setState({
                            isErrorMsg: true,
                            isErrorMsgText: e?.response?.data?.message,
                            selectedOption: "",
                        });
                    } else {
                        this.setState({
                            isErrorMsg: true,
                            isErrorMsgText: e.message,
                            selectedOption: "",
                        });
                    }
                });
        } catch (e) {
            this.setState({
                isErrorMsg: true,
                isErrorMsgText: e.message,
                selectedOption: "",
            });
        }
    }

    moreActionOption = (data) => {
        const validStatuses = new Set(["In Progress", "Result Saved"]);
        const multi_option = [
            // { label: "View Document", value: "viewDocument" },
        ];
        // if (validStatuses.has(data?.row?.result_status)) {
        //     multi_option.push({ label: "Print Bar code", value: "printBarCode" });
        // }
        // if (data?.row?.result_status === "Completed" && localGetItem('isNewBilling') === "true") {
            multi_option.push({ label: "Revert Test", value: "revertHistopathologyResult" });
        // }
        return (
            <div>
                <Tooltip title={"More"} placement='top' arrow>
                    <IconButton
                        onClick={(e) => {
                            this.setState({
                                anchorEl: e.currentTarget,
                                selectedRow: data.id,
                                isSelected: true
                            });
                        }}
                    >
                        <MoreVertIcon />
                    </IconButton>
                </Tooltip>
                {(this.state.isSelected && this.state.selectedRow == data.id) ?
                    <Menu
                        anchorEl={this.state.anchorEl}
                        open={Boolean(this.state.anchorEl)}
                        onClose={() => {
                            this.setState({ anchorEl: null });
                        }}
                    >
                        {multi_option.map((option) => (
                            <MenuItem key={option.value}
                                disabled={option.value === "viewDocument" ? !(data?.row?.result_document?.length > 0) : option.value === "revertHistopathologyResult" ? (data?.row?.result_status !== "Completed") : false}
                                onClick={() => {
                                    if (option.value === "viewDocument") {
                                        this.getS3KeyPR(data?.row?.result_document[0]?.document_file, data?.row?.result_document[0]?.document_name);
                                    } else if (option.value === "printBarCode") {
                                        this.printBarCode(data?.row?.bill_summary_id, data?.row?.id);
                                    } else if (option.value === "revertHistopathologyResult") {
                                        this.setState({
                                            selectedOption: "Revert",
                                            selectedID: data?.row?.id
                                        });
                                    }
                                }}>
                                {option.label}
                            </MenuItem>
                        ))}
                    </Menu> : null}
            </div>
        );
    }

    closePrintPreview = () => {
        this.setState({
            printPreviewPop: false,
            printPreviewData: '',
            printImgData: '',
            pdfName: ''
        });
    }

    ClosePopUp = () => {
        this.setState({ pdfPreview: false, pdfData: '', ImgData: '' })
    }

    render() {
        const columns = [
            {
                field: 'sno', headerName: 'S.No', flex: 0.1,
                renderCell: (params) => (<Box>{params?.value}</Box>)
            },
            {
                field: 'testName', headerName: 'Test Name', flex: 0.25,
                renderCell: (params) => (<Box>{params?.value || '-'} <Typography sx={{fontSize:'0.8vw', color:'gray'}} >{params?.row?.isOutsource === true ? '(Outsource)' : ''}</Typography></Box>)
            },
            {
                field: 'specimen', headerName: 'Specimen', flex: 0.2,
                renderCell: (params) => (params?.row?.specimen ? params?.row?.specimen.length > 25 ?
                    <Tooltip placement="top" title={params?.row?.specimen} arrow>
                        < Box>{ (params.value?.slice(0, 25)+ '...' ) || '-'}  </Box>
                    </Tooltip>: < Box>{ params.value || '-'}  </Box> : '-'
                )
            },
            {
                field: 'sampleId', headerName: 'Sample ID', flex: 0.15,
                renderCell: (params) => (params?.row?.sampleId ?params?.row?.sampleId.length > 19 ?
                    <Tooltip placement="top" title={params?.row?.sampleId} arrow>
                        <Box>{(params.value?.slice(0, 19) + '...') || '-'}</Box>
                    </Tooltip>: <Box>{params.value || '-'}</Box> : '-'
            )
            },
            {
                field: 'overallSpecimenSequence', headerName: 'Overall Specimen Sequences No', flex: 0.2,
                renderCell: (params) => (<Box>{params.value || '-'}</Box>)
            },
            ...(!userAccess ? [] : [{
                field: 'action', headerName: 'Action', flex: 0.1, headerAlign: "center", align: "center",
                renderCell: (params) => (   
                    <Box component={'div'} display={'flex'} alignItems={'center'}>
                        { params?.row?.isOutsource ?
                        <Box>
                            <Button className='Common_Btn_Min_Width' sx={{ height: '1.5vw' }} emed_tid='histo_bill_upl'
                                // disabled={!CheckAccessFunc('Histopathology', "Home", 'Reports', 'Test Reports', "SubTab")?.editAccess}
                                disabled={params?.row?.sampleCollected === false}
                                // onClick={() => this.handleOutsourceUpload(params?.row)}>
                                onClick={() => {
                                    this.setState({ selectedImageRowId: params.row.id, uploadData: params.row })
                                    this.sourceOpen(params.row, params.row.id)
                                }}>
                                <Box component={'img'} src={params?.row?.sampleCollected === false ? ImagePaths.DisableUpload.default :ImagePaths.UploadBtnTheme.default} height={'1.5vw'} width={'1.5vw'} />
                            </Button>  
                        </Box>:
                        <Box>
                        {params?.row?.result_status === "In Progress" || params?.row?.result_status === "Result Saved" ? 
                            <Button className='Common_Btn_Min_Width' sx={{ height: '1.5vw' }} emed_tid='histo_bill_upl'
                                // disabled={!CheckAccessFunc('Histopathology', "Home", 'Reports', 'Test Reports', "SubTab")?.editAccess}
                                disabled={params?.row?.sampleCollected === false}
                                onClick={() => this.handleHistopathologyUpload(params?.row)}>
                                <Box component={'img'} src={params?.row?.sampleCollected === false ? ImagePaths.DisableUpload.default : ImagePaths.UploadBtnTheme.default} height={'1.5vw'} width={'1.5vw'} />
                            </Button> :
                            <Button className='Common_Btn_Min_Width' sx={{ height: '1.5vw' }} emed_tid='histo_bill_view'
                                onClick={() => this.handleViewResult(params?.row)}
                                disabled={!CheckAccessFunc('Histopathology', "Home", 'Reports', 'Test Reports', "SubTab")?.editAccess}>
                                <Box component={'img'} src={ImagePaths.LabViewButton.default} height={'1.5vw'} width={'1.5vw'} />
                            </Button>}

                        {params?.row?.result_status === "Result Saved" || params?.row?.result_status === "Completed" || params?.row?.result_status === "Dispatched" ?
                            <Button className='Common_Btn_Min_Width' onClick={() => { this.handlePrintReport(params?.row) }}>
                                <Box component={'img'} src={ImagePaths.PrintIcons.default} height={'1.5vw'} width={'1.5vw'} />
                            </Button> :
                            <Button className='Common_Btn_Min_Width'>
                                <Box component={'img'} src={ImagePaths.LabPrintIconOff.default} height={'1.5vw'} width={'1.5vw'} />
                            </Button>}
                        </Box>}

                        {/* {this.moreActionOption(params)} */}
                    </Box>
                )
            }])
        ];

        let data = {
            lineOne: "Attender Name",
            lineTwo: `${this.state.attender_name ? this.state.attender_name : "-"}`,
            lineFour: "Contact Number",
            LineFive: `${this.state.attender_mobile ? this.state.attender_mobile : "-"}`
        };

        return (
            <Box component={'div'}>
                <Box component={'div'} sx={{ backgroundColor: Colors.Background, height: '73vh' }}>
                    <Box component={'div'} height={"9.5vh"}>
                        <Box component={'div'} display={'flex'}>
                            <Box component={'div'} className='eMed_nur_notes_details' ml={'0.5vw'}>
                                <CommonPatientDetails data={this.state.patientData} showDetailed={(this.state.patientData?.op_number || this.state.patientData?.ip_number) ? true : false} />
                            </Box>
                        </Box>
                    </Box>
                    <Box component={'div'} m={'0.5vw'} height={'61vh'} sx={{ backgroundColor: Colors.white }}>
                        <DataGrid
                            columns={columns}
                            rows={this.state.testServiceData}
                            getRowId={(row) => row.id}
                            page={this.state.page}
                            pageSize={this.state.pageSize}
                            hideFooterSelectedRowCount
                            localeText={{
                                toolbarColumns: "",
                                toolbarDensity: "",
                                toolbarExport: "",
                                toolbarFilters: "",
                                toolbarExportPrint: ""
                            }}
                            headerHeight={40}
                            components={{
                                Toolbar: CommonGridHeader.CommonToolBar,
                                NoRowsOverlay: () => (
                                    <Box className='eMed_conf_nodata'>
                                        {'No Records To Be Shown'}
                                    </Box>
                                )
                            }}
                            rowsPerPageOptions={[10, 20, 30]}
                            disableSelectionOnClick
                            pagination
                            onPageChange={(newPage) => { this.setState({ page: newPage }) }}
                            onPageSizeChange={(newPageSize) => this.setState({ pageSize: newPageSize })}
                            loading={this.state.isLoader}
                        />
                    </Box>
                </Box>
                   {/* {this.state.sourceOpen && this.renderSourceModal()} */}
                {this.state.sourceOpen ? this.handleOutsourceUpload(this.state.uploadData, this.state.selectedImageRowId) : null}
                {this.renderResultUploadPopup()}
                {this.state.printPreviewPop ?
                    <PrintPreviewPop
                        Data={this.state.printPreviewData}
                        ImageData={this.state.printImgData}
                        Title={this.state.pdfName}
                        BillData={this.state.selectedRow}
                        ClosePopUp={() => { this.closePrintPreview() }}
                        history={this.props.history}
                    /> : null}
                {
                    this.state.imgCapClked && <OpenWebCamPopUP
                    capturedImg={this.state.CapturedImg}
                    closePopup={this.closeWebCamPop.bind(this)}
                    addImgCapture={this.addImgCapture.bind(this)}
                    />
                }
                {this.state.isErrorMsg ?
                    <ToastMsg
                        severity={'error'}
                        msg={this.state.isErrorMsgText}
                        msgPop={this.msgClose.bind(this)}
                    />
                    : null}
                {this.state.successMsg ?
                    <ToastMsg
                        severity={'success'}
                        msg={this.state.successMsgText}
                        msgPop={this.msgClose.bind(this)}
                    />
                    : null}
                {this.state.isInfoMsg ?
                    <ToastMsg
                        severity={'info'}
                        msg={this.state.isInfoMsgText}
                        msgPop={this.msgClose.bind(this)}
                    />
                    : null}
                {this.state.confirmpopup ?
                    <DeletePopup DeletTitle={"Are you sure you want to dispatch ?"}
                        deleteAlertPopupClose={this.PopupClose.bind(this)}
                        removeData={this.postResultTemplateData.bind(this)}
                        ButtonText={"Confirm"}
                    />
                    : null}
                {
                    this.state.pdfPreview ?
                        <PrintPreviewPop
                            Data={this.state.pdfData}
                            ImageData={this.state.ImgData}
                            Title={"PDF Preview"}
                            ClosePopUp={this.ClosePopUp.bind(this)}
                            history={this.props.history}
                        /> : null
                }
                {
                    this.state.selectedOption === "Revert" ?
                        <ReasonPopup
                            title={"Are you sure? Do you want to Revert This "}
                            AlertPopupClose={this.reasonPopupClose.bind(this)}
                            label={"Enter the Reason"}
                            btntext={'Cancel'}
                            btnvarient={'outlined'}
                            btncolor={'error'}
                            btntext1={'Confirm'}
                            btnvarient1={'contained'}
                            sendCmt={this.revertHistopathologyResult.bind(this)}
                        /> : null
                }
            </Box>
        );
    }
}